import { Guid } from '../model/guid';
import { trackingAction } from './student/tracking/itemsTrackingActions';
import { Hotspot } from '@ael/core-api';
import {contentItemAction} from '../../actions/contentItemActions';
import {menuAction} from '../../actions/menuActions';

export type CurrentHotspotReducerState = { hotspot: Hotspot | null; selectedTabId: Guid | null };

export const currentHotspotReducer = (
  state: CurrentHotspotReducerState = { hotspot: null, selectedTabId: null },
  action: any
): CurrentHotspotReducerState => {
  switch (action.type) {
    case contentItemAction.NonSequencedContent_Selected:
      return { hotspot: action.payload, selectedTabId: action.payload.tabs.first() };
    case contentItemAction.NonSequencedContent_TabViewed:
      return { ...state, selectedTabId: action.payload.viewedTabId };
    case menuAction.SideMenu_SelectNonSequencedFlowItem:
    case menuAction.SideMenu_SelectSequencedFlowItem:
    case menuAction.SideMenu_SelectedQuiz:
    case menuAction.SideMenu_DeselectItem:
    case menuAction.SideMenu_NavigateBack:
    case menuAction.SideMenu_SelectedSubmenuItem:
    case menuAction.SideMenu_SelectedResource:
    case contentItemAction.NonSequencedContent_Dismissed:
    case trackingAction.Tracking_ResetProgress:
    case menuAction.SideMenu_SelectHotspot:
      return { hotspot: null, selectedTabId: null };
    default:
      return state;
  }
};
